module.exports = __webpack_public_path__ + "img/ribbon.ca4e80ec.svg";